export const buttonGroup = {
  paddingLeft: 6,
}

export const header = {
  fontSize: '93%',
}
